import { Button, Center, Code, Stack, Text, Title } from "@mantine/core";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { NotFound } from "./NotFound";

/** Router error boundary: render errors in any route land here instead of a blank page. */
export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />;
  return (
    <Center py={120}>
      <Stack align="center" gap="xs" maw={560}>
        <Title order={2}>Something went wrong</Title>
        <Text c="dimmed">The page failed to render. Reload to try again.</Text>
        {import.meta.env.DEV && error instanceof Error && <Code block>{error.message}</Code>}
        <Button onClick={() => window.location.reload()} mt="sm">
          Reload
        </Button>
      </Stack>
    </Center>
  );
}
